var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262e37",
    d: "M7 3c-3.9 0-7 3.1-7 7v35h14V10c0-3.9-3.1-7-7-7",
    "data-original": "#262e37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3f4a5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 41h48v2H0z",
    "data-original": "#3f4a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 42h2v3H4zm-4 0h2v3H0zm8 0h2v3H8zm4 0h2v3h-2zm4 0h2v3h-2zm4 0h2v3h-2zm4 0h2v3h-2zm4 0h2v3h-2zm4 0h2v3h-2zm4 0h2v3h-2zm4 0h2v3h-2zm4 0h2v3h-2z",
    "data-original": "#3f4a5a"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e5e5",
    d: "M16 9h2v2h-2zm4 0h18v2H20zm22 0h6v2h-6zm-3 4h6v2h-6zM18 5h10v2H18zm12 0h2v2h-2z",
    "data-original": "#e6e5e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M48 30v2c0 2-.8 3.7-2.1 5-1.3 1.2-3 2-4.9 2H0V15h27c9.9 0 18 7 21 15",
    "data-original": "#efefef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#84d7e8",
    d: "M47.1 28H40c-7.2 0-13-5.8-13-13 9 0 16.6 5.9 20.1 13",
    "data-original": "#84d7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccbca",
    d: "M38 39H0v-5h34c2.2 0 4 1.8 4 4z",
    "data-original": "#cccbca"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f4a5a",
    d: "M26 37c0 2.2 1.8 4 4 4s4-1.8 4-4zm-10 0c0 2.2 1.8 4 4 4s4-1.8 4-4z",
    "data-original": "#3f4a5a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e66847",
    d: "M0 30h48v2H0z",
    "data-original": "#e66847"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f4a5a",
    d: "M46 30h2v2h-2z",
    "data-original": "#3f4a5a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#84d7e8",
    d: "M12 22c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-2c0-.5.5-1 1-1h8c.5 0 1 .5 1 1zm12 0c0 .5-.5 1-1 1h-8c-.5 0-1-.5-1-1v-2c0-.5.5-1 1-1h8c.5 0 1 .5 1 1z",
    "data-original": "#84d7e8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f4a5a",
    d: "M2 25h2v2H2zm4 0h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2z",
    "data-original": "#3f4a5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.6bb16e7f859dfe71d2e813cc041561fc.svg";
export { ForwardRef as ReactComponent };